import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { addValidationRule, HOC as FormsyHOC } from 'formsy-react';
import FlatButton from 'material-ui/FlatButton';

const styles = {
    parent: {
        position: 'relative'
    },
    file: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
        zIndex: 10
    },
    button: {
        position: 'relative',
        zIndex: 1
    }
};

const hashString = (string) => string.split("").reduce((hash, char) => ((hash << 5) - hash + char.charCodeAt(0) ) & 0xFFFFFFFF);
const generateId = (name, label = '') => `frc-${name.replace(/\[/g, '_').replace(']', '')}-${hashString(JSON.stringify(label))}`;

const generateValidator = ({allowedMimeTypes}) => {
    if (!allowedMimeTypes || allowedMimeTypes.length === 0) { return (values, value) => true; }
    return ((values, value) => {
        if (!value || !value.type) { return true }
        return allowedMimeTypes.includes(value.type);
    });
};

class FormsyFileUpload extends Component {

    componentDidMount() {
        this.setValidations(this.props);
        this.changeValue = this.changeValue.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setValidations(props);
    }

    setValidations(props) {
        addValidationRule('isValidFile', generateValidator(props));
        props.setValidations('isValidFile', props.required);
    }

    render() {
        const value = this.props.getValue();
        const buttonLabel = (value && value.name) || this.props.hintText;
        const valid = this.props.isValid();

        return (
            <div style={styles.parent} className={this.props.required ? 'required' : ''}>
                <FlatButton
                    label={buttonLabel}
                    labelPosition="before"
                    secondary={valid}
                    style={styles.button}
                />
                <input
                    ref="element"
                    type="file"
                    id={this.props.id || generateId(this.props.name, this.props.label)}
                    onChange={this.changeValue}
                    disabled={this.props.disabled}
                    style={styles.file}
                />
                {(this.props.showError() && !!this.props.errorMessage) && <div className="error">{this.props.errorMessage}</div>}
            </div>
        );
    }

    changeValue({target}) {
        this.setState({fileDetails: target.files[0]});
        this.props.setValue(target.files[0]);
        this.props.onChange(this.props.name, target.files[0], target.value);
    }

}

FormsyFileUpload.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string,
    label: PropTypes.string,
    errorMessage: PropTypes.string,
    onChange: PropTypes.func,
    allowedMimeTypes: PropTypes.arrayOf(PropTypes.string),
    required: PropTypes.bool,
    hintText: PropTypes.string
};

FormsyFileUpload.defaultProps = {
    disabled: false,
    validatePristine: false,
    onChange: f => f,
    hintText: 'Browse',
};

export default FormsyHOC(FormsyFileUpload);

